// @react
import React, { ReactElement } from 'react'
// @types
import { GetUserQuery, GetUserQueryVariables } from 'lib/graphql/graphqlTypes'
// @graphql
import { useQuery } from '@apollo/client'
import { GET_USER } from 'graphql/queries/user.query'
// @components
import Box from '@bit/atd.web.box'
import SkeletonLoader from '@bit/atd.web.loaders.skeleton'
// @module components
import MembershipForm from 'modules/profile/components/Membership/Form'
import QueryError from 'modules/common/components/Errors/QueryError'

/**
 * 5.0.3.1 Profile - Membership - Details
 * UX: https://www.figma.com/file/jCo0D2EYkVbuBX1TjR1enA/ATD-MyATD-Desktop-2020?node-id=3247%3A3519
 *
 *
 * endpoint: user/profile
 * response: UserProfileDTO
 *
 *  IMembership
 *     memberType: MemberType
 *     memberNumber: Int
 *     memberStatus: MemberStatus
 *     autoRenew: Boolean
 *     initialBeginDate: Date
 *     cycleEndDate: Date
 * currentMembership: IMembership
 * futureMembership: IMembership
 * chapterMembership: IMembership
 *    chapterName
 */

type PropsType = any

const Details = (props: PropsType): ReactElement => {
  /****************************************
   *  HOOKS
   ****************************************/

  const { loading: isLoading, error: isError, data, refetch } = useQuery<
    GetUserQuery,
    GetUserQueryVariables
  >(GET_USER, {
    fetchPolicy: 'cache-first',
    // notifyOnNetworkStatusChange: true, // @todo a bit crude with refetch, should really modify cache directly
  })

  /****************************************
   *  RENDER
   ****************************************/

  if (isLoading)
    return (
      <Box>
        <SkeletonLoader />
      </Box>
    )

  if (isError || (!data && !isLoading)) return <QueryError />

  return (
    <>
      <MembershipForm data={data} refetch={refetch} />
    </>
  )
}

export default Details
